import {
  useCuentaContableEmpresaComisionAperturaPrestamoRecibido,
  useCuentaContableEmpresaComisionCorretajePrestamoRecibido,
  useCuentaContableEmpresaComisionDisposicionPrestamoRecibido,
  useCuentaContableEmpresaComisionEstudioPrestamoRecibido,
  useCuentaContableEmpresaComisionOtraPrestamoRecibido,
  useCuentaContableEmpresaInteresPrestamoRecibido,
  useCuentaContableEmpresaPrestamoRecibido,
} from "api/CuentaContableEmpresa.hook"
import {
  useCuentaContableCuentaComisionAperturaPrestamoRecibido,
  useCuentaContableCuentaComisionCorretajePrestamoRecibido,
  useCuentaContableCuentaComisionDisposicionPrestamoRecibido,
  useCuentaContableCuentaComisionEstudioPrestamoRecibido,
  useCuentaContableCuentaComisionOtraPrestamoRecibido,
  useCuentaContableCuentaInteresPrestamoRecibido,
  useCuentaContableCuentaPrestamoRecibido,
} from "api/CuentaContable_Cuenta.hook"
import { DropdownCuentasContablesConModal } from "common/components/DropdownsCuentasContables/DropdownCuentasContablesConModal/DropdownCuentasContablesConModal"
import { DropdownChangeParams } from "primereact/dropdown"
import { useTranslation } from "react-i18next"

const PrestamoRecibidoConfiguracion = ({
  initialPorDefectoPrestamoRecibido,
  handleSetPrestamo,
  initialPorDefectoPrestamoInteresRecibido,
  handleSetPrestamoInteres,
  initialPorDefectoPrestamoComisionAperturaRecibido,
  initialPorDefectoPrestamoComisionEstudioRecibido,
  initialPorDefectoPrestamoComisionDisposicionRecibido,
  initialPorDefectoPrestamoComisionCorretajeRecibido,
  initialPorDefectoPrestamoComisionOtrasRecibido,
  handleSetPrestamoApertura,
  handleSetPrestamoEstudio,
  handleSetPrestamoDisposicion,
  handleSetPrestamoCorretaje,
  handleSetPrestamoOtras,
  handlePrestamosCheckbox,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) => {
  const { t } = useTranslation()
  const { prestamoCheckboxState, handleFirstCheckbox, handleSecondCheckbox } =
    handlePrestamosCheckbox()

  const { cuentasContablesEmpresas: cuentasPrestamoBaseRecibido } =
    useCuentaContableCuentaPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoRecibido,
    cuentasContablesEmpresasRefetch: refresListaDeCuentasPrestamoRecibido,
  } = useCuentaContableEmpresaPrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasInteresesPrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaInteresPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoInteresRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasPrestamoInteresRecibido,
  } = useCuentaContableEmpresaInteresPrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionAperturaPrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaComisionAperturaPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionAperturaRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionAperturaPrestamoRecibido,
  } = useCuentaContableEmpresaComisionAperturaPrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionCorretajePrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaComisionCorretajePrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionCorretajeBaseRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionCorretajePrestamoRecibido,
  } = useCuentaContableEmpresaComisionCorretajePrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionOtrosPrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaComisionOtraPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionOtrasBaseRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionOtraPrestamoRecibido,
  } = useCuentaContableEmpresaComisionOtraPrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionEstudioPrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaComisionEstudioPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionEstudioRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionEstudioPrestamoRecibido,
  } = useCuentaContableEmpresaComisionEstudioPrestamoRecibido()

  const {
    cuentasContablesEmpresas:
      listaDeCuentasComisionDisposicionPrestamoRecibidoComprasBase,
  } = useCuentaContableCuentaComisionDisposicionPrestamoRecibido()
  const {
    cuentasContablesEmpresas: cuentasPrestamoComisionDisposicionBaseRecibido,
    cuentasContablesEmpresasRefetch:
      refresListaDeCuentasComisionDisposicionPrestamoRecibido,
  } = useCuentaContableEmpresaComisionDisposicionPrestamoRecibido()

  return (
    <div>
      <div className='tw-mb-4'>
        <div className='tw-mb-4 tw-w-full p-fluid'>
          {t("config.loanTitle")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={
              prestamoCheckboxState.firstCheckbox
                ? cuentasPrestamoBaseRecibido
                : cuentasPrestamoRecibido
            }
            dropdownValue={initialPorDefectoPrestamoRecibido ?? ""}
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamo(e.value)
            }}
            listaDeCuentasBase={cuentasPrestamoBaseRecibido}
            cuentaPorDefecto={initialPorDefectoPrestamoRecibido}
            refreshFetchData={refresListaDeCuentasPrestamoRecibido}
            withCreateCuenta={!prestamoCheckboxState.firstCheckbox}
          />
        </div>
        <div className='tw-inline-flex tw-items-center tw-mb-4'>
          <input
            className='tw-h-5 tw-w-5 tw-accent-primary tw-rounded tw-cursor-pointer tw-mr-3'
            type='checkbox'
            name='recibidoCheckOne'
            id='recibidoCheckOne'
            onClick={() => handleFirstCheckbox()}
            checked={prestamoCheckboxState.firstCheckbox}
          />
          <label className='my-auto'>
            {t("config.crearCuentaContableAutomatica")}
          </label>
        </div>
        <div className='tw-inline-flex tw-items-center'>
          <input
            className='tw-h-5 tw-w-5 tw-accent-primary tw-rounded tw-cursor-pointer tw-mr-3 disabled:tw-cursor-not-allowed'
            type='checkbox'
            name='recibidoCheckTwo'
            id='recibidoCheckTwo'
            disabled={!prestamoCheckboxState.firstCheckbox}
            onClick={() => handleSecondCheckbox()}
            checked={prestamoCheckboxState.secondCheckbox}
          />
          <label className='my-auto'>
            {t("config.asignarMismaCuentaContablePorContacto")}
          </label>
        </div>
      </div>
      <div className='tw-flex tw-flex-row tw-justify-between tw-mb-3 row'>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.interestTitle")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasPrestamoInteresRecibido}
            dropdownValue={initialPorDefectoPrestamoInteresRecibido ?? ""}
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamoInteres(e.value)
            }}
            listaDeCuentasBase={
              listaDeCuentasInteresesPrestamoRecibidoComprasBase
            }
            refreshFetchData={refresListaDeCuentasPrestamoInteresRecibido}
            withCreateCuenta
          />
        </div>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.originationFee")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasPrestamoComisionAperturaRecibido}
            dropdownValue={
              initialPorDefectoPrestamoComisionAperturaRecibido ?? ""
            }
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamoApertura(e.value)
            }}
            listaDeCuentasBase={
              listaDeCuentasComisionAperturaPrestamoRecibidoComprasBase
            }
            cuentaPorDefecto={
              initialPorDefectoPrestamoComisionDisposicionRecibido
            }
            refreshFetchData={
              refresListaDeCuentasComisionAperturaPrestamoRecibido
            }
            withCreateCuenta
          />
        </div>
      </div>

      <div className='tw-flex tw-flex-row tw-justify-between tw-mb-3 row'>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.studyCommission")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasPrestamoComisionEstudioRecibido}
            dropdownValue={
              initialPorDefectoPrestamoComisionEstudioRecibido ?? ""
            }
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamoEstudio(e.value)
            }}
            listaDeCuentasBase={
              listaDeCuentasComisionEstudioPrestamoRecibidoComprasBase
            }
            cuentaPorDefecto={initialPorDefectoPrestamoComisionEstudioRecibido}
            refreshFetchData={
              refresListaDeCuentasComisionEstudioPrestamoRecibido
            }
            withCreateCuenta
          />
        </div>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.arrangementFee")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={
              cuentasPrestamoComisionDisposicionBaseRecibido
            }
            dropdownValue={
              initialPorDefectoPrestamoComisionDisposicionRecibido ?? ""
            }
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamoDisposicion(e.value)
            }}
            listaDeCuentasBase={
              listaDeCuentasComisionDisposicionPrestamoRecibidoComprasBase
            }
            cuentaPorDefecto={
              initialPorDefectoPrestamoComisionDisposicionRecibido
            }
            refreshFetchData={
              refresListaDeCuentasComisionDisposicionPrestamoRecibido
            }
            withCreateCuenta
          />
        </div>
      </div>

      <div className='tw-flex tw-flex-row tw-justify-between tw-mb-3 row'>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.brokerageCommission")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={
              cuentasPrestamoComisionCorretajeBaseRecibido
            }
            dropdownValue={
              initialPorDefectoPrestamoComisionCorretajeRecibido ?? ""
            }
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamoCorretaje(e.value)
            }}
            listaDeCuentasBase={
              listaDeCuentasComisionCorretajePrestamoRecibidoComprasBase
            }
            cuentaPorDefecto={
              initialPorDefectoPrestamoComisionCorretajeRecibido
            }
            refreshFetchData={
              refresListaDeCuentasComisionCorretajePrestamoRecibido
            }
            withCreateCuenta
          />
        </div>
        <div className='mb-2 tw-w-2/4 p-fluid tw-px-[15px]'>
          {t("config.otherCommission")}
          <DropdownCuentasContablesConModal
            cuentasContablesOptions={cuentasPrestamoComisionOtrasBaseRecibido}
            dropdownValue={initialPorDefectoPrestamoComisionOtrasRecibido ?? ""}
            onChange={(e: DropdownChangeParams) => {
              handleSetPrestamoOtras(e.value)
            }}
            listaDeCuentasBase={
              listaDeCuentasComisionOtrosPrestamoRecibidoComprasBase
            }
            cuentaPorDefecto={initialPorDefectoPrestamoComisionOtrasRecibido}
            refreshFetchData={refresListaDeCuentasComisionOtraPrestamoRecibido}
            withCreateCuenta
          />
        </div>
      </div>
    </div>
  )
}

export default PrestamoRecibidoConfiguracion
